import jobs from './apis/jobsearch-api';

export default () => ({
  jobs,
});
